export default __webpack_public_path__ + "static/PickleBall-d4a4229c5d225ad9a0f8b80ec46ad968.png";